/* Huggler — instant loading spinner on navigating buttons (added 2026-08-15).
   Checkout (mini-cart + cart page) and Buy Now (PDP dynamic checkout) show a
   spinner the instant they're tapped, until the page navigates. No fake delay:
   the button's real action (form submit / Shopify checkout) fires as normal;
   we only add a visual "working" state on top. */
(function () {
  'use strict';

  // Native, navigating checkout buttons only. The Shopify dynamic "Buy it now"
  // button is intentionally excluded — it renders its own content and has its own
  // loading state; overlaying ours blanks it out.
  var SELECTOR = '[name="checkout"], #CartDrawer-Checkout, #checkout, .cart__checkout-button';

  function clearSpinner(btn) {
    btn.classList.remove('hug-loading');
    var sp = btn.querySelector(':scope > .hug-spinner');
    if (sp) sp.parentNode.removeChild(sp);
  }

  function showSpinner(btn) {
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    if (btn.classList.contains('hug-loading')) return;
    // Inject a real spinner element (a pseudo-element ::after gets overridden by
    // the theme's own button ::after, which is what blanked the button before).
    if (!btn.querySelector(':scope > .hug-spinner')) {
      var s = document.createElement('span');
      s.className = 'hug-spinner';
      s.setAttribute('aria-hidden', 'true');
      btn.appendChild(s);
    }
    btn.classList.add('hug-loading');
    // Safety net: if navigation never happens (e.g. blocked), clear it so the
    // button isn't stuck spinning. This is a fallback only — not a delay.
    setTimeout(function () {
      clearSpinner(btn);
    }, 12000);
  }

  // Capture phase so the spinner paints before the button's own handler runs.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest(SELECTOR);
      if (btn) showSpinner(btn);
    },
    true
  );

  // Back/forward (bfcache) restore: never show a stale spinner.
  window.addEventListener('pageshow', function () {
    var stuck = document.querySelectorAll('.hug-loading');
    for (var i = 0; i < stuck.length; i++) clearSpinner(stuck[i]);
  });
})();
